<template>
  <div class="baniere">
    <div class="bloc pt-20">
      <div class="md:pt-10">
        <div
          class="title w-full md:mt-6"
          data-aos="fade-right"
          data-aos-duration="2000"
        >
          Carrière
        </div>
        <div class="flex">
          <div
            class="text-white blocc md:p-12 p-6 pr-8 pb-12 cursor-pointer"
            data-aos="fade-up"
            data-aos-duration="2000"
            @click="goBottom"
          >
            <div class="titre1 md:pr-32">
              Découvrez les possibilités actuelles d'emploi, de stage et de bénévolat.
            </div>
          </div>
        </div>
      </div>

      <div class="w-full bloc2 flex justify-end">
        <div class="w-auto">
          <img
            src="../../../assets/icons/courbe.svg"
            alt=""
            data-aos="fade-left"
            data-aos-duration="2000"
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'Index',
  components: {
  },
  props: {
  },
  data () {
    return {

    }
  },
  created () {
  },
  methods: {
    goBottom () {
      this.$emit('oga', true)
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "../../../assets/style/sass/variables";
 .baniere{
   height: 470px;
   background-color: $background-gray-dev;
   padding-left: $padding-l;
   padding-right: $padding-r;
 }

  .button{
    background-color: $dev-green;
    height: 60px;
    border-radius: 0px;
    border: none;
    font-style: normal;
    font-weight: 600;
    font-size: 24px;
    line-height: 29px;
    color: white;
  }
  .title{
    font-style: normal;
    font-weight: 800;
    font-size: 64px;
    line-height: 150%;
    color: $black;
  }
  .titre1{
    font-style: normal;
    font-weight: 600;
    font-size: 48px;
    line-height: 160%;
  }
.blocc{
  background-color: $devs_color;
  z-index: 3;
  width: 100%;
}
  .bloc2{
    position: absolute;
    top: 100px;
    z-index: 1;
  }
  img{
    width: 944px;
    height: 983px;
  }
  @media screen and (max-width: 600px){
    .baniere{
      padding-left: 20px;
      padding-right: 20px;
      height: 300px;

    }
    .title{
      font-size: 60px;
      line-height: 170%;
    }
    .blocc{
      width: 100%;
    }
    .titre1{
      font-size: 26px;
    }
    img{
      position: absolute;
      top: 0px;
      right: -90px;
      height: 650px;
      width: 644px;
    }
    .op{
      position: relative;
      z-index: 1;
    }
  }
  @media screen and (min-width: 701px) and (max-width: 1024px){
    .baniere{
      padding-left: $padding-l-1024;
      padding-right: $padding-r-1024;
    }
    .titre1{
      font-size: 40px;
    }
    .detail{
      font-size: 22px;
    }
  }
</style>
